module.exports = __webpack_public_path__ + "fonts/avenir_medium.7d635ea9.ttf";